import amplitude from 'amplitude-js';
import { isProduction } from 'js/sign-components/common/ts-utils';

const AMPLITUDE_KEY = isProduction() ? '0a9007ec3e21b28256a63131ce5543ce' : '2bb574875a8c8cdc90d138f845bc015d';
const API_ENDPOINT = 'www.dropbox.com/amplitude_proxy/ingest_lenient';

const EVENT_OBJECT_SELF_SIGN = 'self_sign';
const EVENT_OBJECT_SIGNATURE_REQUEST = 'signature_request';
const EVENT_OBJECT_TEMPLATE = 'template';

export const EVENT_SELF_SIGN_SIGN = `sign.${EVENT_OBJECT_SELF_SIGN}`;

export const EVENT_SIGNATURE_REQUEST_SEND = `send.${EVENT_OBJECT_SIGNATURE_REQUEST}`;
export const EVENT_SIGNATURE_REQUEST_SIGN = `sign.${EVENT_OBJECT_SIGNATURE_REQUEST}`;

export const EVENT_TEMPLATE_EDIT = `edit.${EVENT_OBJECT_TEMPLATE}`;
export const EVENT_TEMPLATE_SAVE = `save.${EVENT_OBJECT_TEMPLATE}`;

export function initPAPClient() {
  amplitude.getInstance().init(AMPLITUDE_KEY, undefined, {
    apiEndpoint: API_ENDPOINT,
  });

  return amplitude;
}

export function TrackPAPEvent(
  eventName: string,
  accountId: number,
  userProperties: object = {},
  dbxUserId?: string | null,
) {
  const eventParts = eventName.split('.');
  const eventAction = eventParts[0];
  const eventObject = eventParts[1];
  const amplitudeClient = initPAPClient();

  const eventProperties = {
    // From the event as defined in the PAP UI (https://pap.pp.dropbox.com/):
    user_properties: userProperties,
    event_action: eventAction,
    event_object: eventObject,
    event_class: 'sign',
    user_identifier: {
      user_id: dbxUserId,
      foreign_user_id: accountId,
      // Dropbox is expecting a literal HELLOSIGN value for this API request
      // eslint-disable-next-line no-restricted-syntax
      foreign_user_provider: 'HELLOSIGN',
    },
  };

  amplitudeClient.getInstance().logEvent(eventName, eventProperties);
}

export enum IntegrationNames {
  DeepIntegration = 'deepintegration',
  OfficeSelfSign = 'officeAddInSelfSign',
  SharePoint = 'SharePoint',
  HubSpot = 'hubspot',
  HubSpotV2 = 'hubspotv2',
}

export function retrieveFormattedIntegrationSource(integrationName: string) {
  switch (integrationName) {
    case IntegrationNames.OfficeSelfSign:
      return 'office_add_in';
    case IntegrationNames.DeepIntegration:
      return 'deep_integration';
    case IntegrationNames.HubSpot:
    case IntegrationNames.HubSpotV2:
    case IntegrationNames.SharePoint:
      return integrationName;
    default:
      return 'standalone';
  }

}
